import { Attendee } from '@/types';
import { AttendeeDataObject as EmailAttendee } from '@/types/sendEmail';

export function mapAttendeeToEmailFormat(attendees: Attendee[]): EmailAttendee[] {
  const groupedAttendees: { [key: string]: EmailAttendee } = {};

  attendees.forEach((attendee) => {
    const key = `${attendee.firstName}-${attendee.lastName}-${attendee.email}`;

    if (!groupedAttendees[key]) {
      groupedAttendees[key] = {
        email: attendee.email,
        barcode_numbers: [],
      };
    }

    groupedAttendees[key].barcode_numbers.push(attendee.barcode.barcode);
  });

  return Object.values(groupedAttendees);
}
